<template>
  <div class="sales-total">
    <!-- 총 매출 -->
    <v-layout justify-space-between class="color--orange total-row">
      <v-flex class="d-flex align-center">
        매출
      </v-flex>
      <v-flex class="text-right amount">
        {{ $filters.commaFormat(data.settlementTargetSalesAmount) }} 원
      </v-flex>
    </v-layout>

    <!-- 소스별 매출 내역 -->
    <template v-for="payment in data.paymentsDetail">
      <template v-for="amountDetail in payment.amountDetails">
        <template v-if="amountDetail.title === '매출'">
          <v-layout 
            v-for="detail in amountDetail.data" 
            :key="detail.name"
            justify-space-between 
            class="subtitle detail-row color--nice-grey"
          >
            <v-flex class="d-flex align-center">
              {{ detail.name }}
            </v-flex>
            <v-flex class="text-right">
              {{ $filters.commaFormat(detail.amount) }} 원
            </v-flex>
          </v-layout>
        </template>
      </template>
    </template>

    <!-- <p class="notice">타밴 매출이 있는 경우, 오후 5시 반영됩니다.</p> -->
  </div>
</template>

<script>
import { sumByPropertyName } from '@/util/mathUtil'

export default {
  props: ['data'],
  methods: {
    sumByPropertyName,
  },
}
</script>

<style lang="scss" scoped>
.sales-total {
  .total-row {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    
    .amount {
      font-size: 20px;
      font-weight: 700;
    }
  }

  .detail-row {
    margin: 12px 0;
    font-size: 15px;
    padding-left: 15px;
  }

  img.icon {
    width: 22px;
    margin-right: 8px;
  }

  .notice {
    margin-top: 16px;
    margin-bottom: 0;
    font-size: 13px;
    text-align: center;
    color: #666;
  }
}
</style>
